import { render } from "./PriorityChart.vue?vue&type=template&id=35134b37&scoped=true"
import script from "./PriorityChart.vue?vue&type=script&lang=js"
export * from "./PriorityChart.vue?vue&type=script&lang=js"

import "./PriorityChart.vue?vue&type=style&index=0&id=35134b37&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35134b37"]])

export default __exports__